var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditDuonut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5771 6.06787C19.7298 6.06787 19.8763 6.12853 19.9842 6.23651L23.2413 9.49356C23.4661 9.71841 23.4661 10.083 23.2413 10.3078L12.6559 20.8932C12.5835 20.9656 12.4932 21.0173 12.3942 21.0432L7.98566 22.1947C7.78789 22.2464 7.57755 22.1893 7.43302 22.0448C7.28848 21.9002 7.23141 21.6899 7.28307 21.4921L8.43461 17.0835C8.46046 16.9846 8.51222 16.8943 8.58456 16.8219L19.17 6.23651C19.2779 6.12853 19.4244 6.06787 19.5771 6.06787Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36317 24.2046C6.88618 24.2046 6.49951 24.5913 6.49951 25.0683C6.49951 25.5453 6.88618 25.932 7.36317 25.932H24.6363C25.1133 25.932 25.4999 25.5453 25.4999 25.0683C25.4999 24.5913 25.1133 24.2046 24.6363 24.2046H7.36317Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDuonut);
export default __webpack_public_path__ + "static/media/edit-duonut.0d912aa071767256d115f39cafd3617c.svg";
export { ForwardRef as ReactComponent };